import { render } from "./S137083.vue?vue&type=template&id=798b4b9d"
const script = {}
script.render = render

export default script